module.exports = __webpack_public_path__ + "img/no-tran.830be95f.svg";